import { render, staticRenderFns } from "./mainBody.vue?vue&type=template&id=71858b58&scoped=true"
import script from "./mainBody.vue?vue&type=script&lang=js"
export * from "./mainBody.vue?vue&type=script&lang=js"
import style0 from "./mainBody.vue?vue&type=style&index=0&id=71858b58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71858b58",
  null
  
)

export default component.exports